export default {"src":"/_next/static/image/public/images/flags/flag_387.0fe9ea7cb8907880aa4aca08d5a1ed9e.svg","height":16,"width":24};